import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import creditworthinessComponent from './creditworthiness.component';
import creditworthinessCard from './creditworthinessCard/creditworthinessCard';
import creditworthinessMoreInfo from './creditworthinessMoreInfo/creditworthinessMoreInfo';
import creditworthinessOfLoan from './creditworthinessOfLoan/creditworthinessOfLoan';
import creditworthinessMobileHeader from './creditworthinessMobileHeader/creditworthinessMobileHeader';

let creditworthinessModule = angular.module('creditworthiness', [
  uiRouter,
  creditworthinessMoreInfo,
  creditworthinessCard,
  creditworthinessOfLoan,
  creditworthinessMobileHeader
])

  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state(STATES.LOANS.CREDITWORTHINESS, {
        url: ROUTES.LOANS.CREDITWORTHINESS,
        component: 'creditworthiness',
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          serviceClosed: (StatusAppCheckers) => StatusAppCheckers.isServiceClosed()
        }
      });
  })

  .component('creditworthiness', creditworthinessComponent)

  .name;

export default creditworthinessModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthiness.js